<div id="root"
     [ngClass]="{
      rtl: globalStateService.isRtl(),
      ltr: !globalStateService.isRtl(),
      'light-theme': globalStateService.theme() === 'light',
      'dark-theme': globalStateService.theme() === 'dark',
     }"
     [attr.data-bs-theme]="globalStateService.theme() === 'dark' ? 'dark' : 'light'">
      <!-- These are used by reference js functions to get color computed -->
      <!-- <span id="dark-theme-reference"
        class="dark-theme d-none"
        data-bs-theme="dark"></span>
  <span id="light-theme-reference"
        class="light-theme  d-none"
        data-bs-theme="light"></span> -->
      <router-outlet></router-outlet>
      <app-toasts aria-live="polite"
                  aria-atomic="true"></app-toasts>
</div>